import { StatusBadge, type StatusBadgeProps } from "@/components/shared/StatusBadge";
import { INSTALLMENT_STATUS_META, statusMeta } from "@/lib/statusTone";

/**
 * Pílula de status de parcela: liga o status (já passado por
 * `effectiveInstallmentStatus` quando o vencimento importa) ao rótulo/tom de
 * INSTALLMENT_STATUS_META. Usada no Financeiro e no plano de pagamento do lead.
 */
export interface InstallmentStatusBadgeProps extends Pick<StatusBadgeProps, "shape" | "className"> {
  status: string;
}

export function InstallmentStatusBadge({
  status,
  shape = "tag",
  className,
}: InstallmentStatusBadgeProps) {
  const meta = statusMeta(INSTALLMENT_STATUS_META, status);
  return (
    <StatusBadge shape={shape} tone={meta.tone} className={className}>
      {meta.label}
    </StatusBadge>
  );
}
